// extracted by mini-css-extract-plugin
module.exports = {"BigTitle":"BigTitle_BigTitle__303Gv"};